export interface IDonorProfileRecords {
    donorId: number,
    donorAlias: string,

    medChartUploadPath: string,
    medChartUploadDate: string,

    ctReportUploadPath: string,
    ctReportUploadDate: string,

    rawTypingUploadPath: string,
    rawTypingUploadDate: string,

    centerAboUploadPath: string,
    centerAboUploadDate: string,

    vrlAboUploadPath: string,
    vrlAboUploadDate: string,

    vrlAboMolecularUploadPath: string,
    vrlAboMolecularUploadDate: string,

    vrlAboA2ConfirmatoryUploadPath: string,
    vrlAboA2ConfirmatoryUploadDate: string,

    vrlHlaUploadPath: string,
    vrlHlaUploadDate: string,

    histogeneticsPdfTypingFile: string,
    histogeneticsPdfTypingUploadDate: string,

    histogeneticsPdfAboFile: string,
    histogeneticsPdfAboUploadDate: string,

    covidTestUpload: string,
    
    serologyUploadPath: string,
    serologyUploadDate: string,

    canOrderCryo: boolean,

    hasCtScanOnline: boolean,
}